import { useEffect, useState } from "react";
import { useArt } from "../../stores/useArt";
import { useProfile } from "../../stores/useProfile";
import { StyledArtmenu } from "./ArtMenu.styled";
import { Art } from "../../Models/Art";
import { Box, Button, Typography } from "@mui/material";
import { SERVERURL } from "../../Globals/Constants";
import { PlusIcon, TrashSimpleIcon } from "@phosphor-icons/react";

type ArtMenuProps = {
  artItemId: number;
};

export const ArtMenu = ({ artItemId }: ArtMenuProps) => {
  const { fetchArt, addArtImage, removeArtImage, changeMainImage } = useArt();
  const { user } = useProfile();
  const [artItem, setArtitem] = useState<Art>();

  useEffect(() => {
    fetchItem();
  }, []);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const newFiles = Array.from(files);
    if (!user) return;
    const res = await addArtImage(user, artItemId, newFiles);
    if (res === 201) fetchItem();
  };

  const fetchItem = async () => {
    if (!user) return;
    const res = await fetchArt(user, artItemId);
    setArtitem(res);
    
  };

  const handleRemove = async (fileId: number) => {
    if (!user) return;
    const res = await removeArtImage(user, artItemId, fileId);

    if (res === 200) fetchItem();
  }

  const handleSelect = async (fileId: number) => {
    if (!user) return;
    const res = await changeMainImage(user, artItemId, fileId);

    if (res === 200) fetchItem();
  }

  return (
    <StyledArtmenu>
      <Typography variant="h2">Foto's aanpassen</Typography>
      <Box className="content">
        {artItem?.files.map((file) => (
          <Box className={`imageWrapper ${artItem.mainImage.id === file.id && "selected"}`} onClick={() => handleSelect(file.id)}>
            <img src={`${SERVERURL}${file.filePath}`} />
            {artItem.mainImage.id !== file.id  && <Button className="removebtn">
              <TrashSimpleIcon size={32} weight="bold" onClick={() => handleRemove(file.id)}/>
            </Button>}
          </Box>
        ))}
        <Button className="addImageBtn" variant="contained" component="label" >
          <PlusIcon size={64} />
          <input
            hidden
            accept="image/*"
            type="file"
            multiple
            onChange={handleFileChange}
          />
        </Button>
      </Box>
    </StyledArtmenu>
  );
};
